import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Zm-5.6 12.43H6.3v-.02a.5.5 0 0 1 0 1H3.22a.53.53 0 0 1-.39-.18.49.49 0 0 1-.09-.42 3.06 3.06 0 0 1 1.57-1.78c.91-.54 1.37-1.01 1.37-1.4 0-.77-.63-.88-1-.88a.92.92 0 0 0-1 .68.51.51 0 0 1-.6.38.5.5 0 0 1-.38-.59 1.94 1.94 0 0 1 2-1.47 1.83 1.83 0 0 1 1.99 1.9c0 1.02-.99 1.74-1.86 2.26-.247.145-.475.32-.68.52Zm2.034-6.556a.5.5 0 0 0-.394-.854h-.57V5.78a.51.51 0 0 0-.79-.41l-1 .69a.503.503 0 1 0 .57.83l.26-.16v3.54h-.57a.5.5 0 0 0 0 1h2.14a.5.5 0 0 0 .354-.146ZM9 12a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 12Zm.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListNumberIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListNumber')) as IconWithRender;

TextListNumberIcon.displayName = 'TextListNumberIcon';
TextListNumberIcon.propTypes = Icon.propTypes;
TextListNumberIcon.renderIcon = (props) => <TextListNumberIcon {...props} />;
export default TextListNumberIcon;
